import { render, staticRenderFns } from "./ServicesCategories.vue?vue&type=template&id=bb4fd142&scoped=true"
import script from "./ServicesCategories.vue?vue&type=script&lang=js"
export * from "./ServicesCategories.vue?vue&type=script&lang=js"
import style0 from "./ServicesCategories.vue?vue&type=style&index=0&id=bb4fd142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4fd142",
  null
  
)

export default component.exports